import { getWidgetProps } from '../../inputs/common/util/getWidgetProps.ts';
import { TableInputContainer } from './render/TableInputContainer.tsx';
import { type ITableInputWidgetProps } from './TableInputWidgetComponent.tsx';

export function TableInputWidgetPreview(props: ITableInputWidgetProps) {
  const options = getWidgetProps(props);

  return (
    <TableInputContainer {...props} options={options}>
      {props.children}
    </TableInputContainer>
  );
}
